module.exports = {"540627100":"普保镇","540627101":"北拉镇","540627102":"德庆镇","540627103":"佳琼镇","540627205":"尼玛乡","540627207":"保吉乡","540627209":"青龙乡","540627211":"马前乡","540627215":"门当乡","540627216":"新吉乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540627.json
// module id = 2742
// module chunks = 0